export default "__VITE_ASSET__BGKFVLn4__"